import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography, UploadFile } from "antd";
import { useGetProductById, useUpdateProduct } from "hooks/useProduct";
import { FC, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import {
  AttributeInput,
  UpdateProductInput,
  PriceProductByIdResponse,
  TagNameData,
  CategoryData,
} from "services/interface";
import type { PricesInput } from "./interface";
import MainUpdateProduct from "./MainUpdateProduct";
import { backendUrl } from "config";
import UpdateProductProduct from "./UpdateProductFooter";
import _ from "lodash";
import { useQueryClient } from "@tanstack/react-query";
import { useGetMasterTagName } from "hooks/useMasterData";
import { useGetAllCategory } from "hooks/useCategory";
import { toMerchantIdArray } from "utils";
import { navigateBackToManageProduct } from "utils/session/manageProductReturnSession";
import { useUnsavedChangesGuard } from "hooks/useUnsavedChangesGuard";


interface UpdateProductProps {
  id: string;
}

const UpdateProduct: FC<UpdateProductProps> = ({ id }) => {
  const userProfile = useAppSelector((state) => state.auth.profile);
  const { data, isPending, isError } = useGetProductById(id);
  //console.log("FactoryData",data)
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { mutate, isPending: mutateLoading } = useUpdateProduct();

  const [attribute, setAttribute] = useState<AttributeInput[]>([]);
  const [variants, setVariants] = useState<VariantsInput>([]);
  const [prices, setPrices] = useState<PricesInput>([]);
  const [images, setImages] = useState<UploadFile[]>();
  const queryClient = useQueryClient();
  const [checkIsActive, setCheckIsActive] = useState<boolean>(false);
  const [checkIsRecommend, setCheckIsRecommend] = useState<boolean>(false);
  const [checkIsApproved, setCheckIsApproved] = useState<boolean>(false);
  const [checkIsShowApp, setCheckIsShowApp] = useState<boolean>(false);
  // ✅ ผู้ใช้แก้ไขข้อมูลระดับสินค้าแล้วแต่ยังไม่กด "อัพเดตสินค้า"
  const [isDirty, setIsDirty] = useState<boolean>(false);
  // ✅ ตั้งค่า field ระดับสินค้าจาก data ครั้งเดียว (กัน refetch จากการแก้ SKU มา reset ค่าที่ยังไม่บันทึก)
  const initializedRef = useRef(false);
  // ✅ เก็บ mapping ระหว่าง item.id กับ variant.id เดิม
  const [itemToVariantMap, setItemToVariantMap] = useState<Record<string, string>>({});

  //เก็บ Role Type ของ User
  const [roleType, setRoleType] = useState<string>('');

  // ✅ State สำหรับ disabled ปุ่มอัพเดทเมื่อไม่มี SKU
  const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = useState<boolean>(false);
  // ✅ เก็บค่าจากฐานข้อมูลไว้ใน state เพื่อใช้สำหรับ restore c1-c3 เมื่อ total_commission กลับเป็นค่าเดิม
  const [originalPrices, setOriginalPrices] = useState<PricesInput>([]);
  // ✅ เก็บ variants จากฐานข้อมูลไว้ใน state เพื่อใช้ restore shipping_method + dimensions + transport เมื่อสลับ bangbow/self
  const [originalVariants, setOriginalVariants] = useState<VariantsInput>([]);

  const factoryId = useAppSelector((state) => state.auth.contact?.id);

  const { data: tagNameData, isLoading: tagNameLoading, refetch: tagNameRefetch } = useGetMasterTagName(factoryId || "");

  const { data: categoryData, isLoading: categoryLoading, refetch: categoryRefetch } = useGetAllCategory();

  // console.log("หน้า update variants",variants);

  const [form] = Form.useForm();

  // ✅ แจ้งเตือนเมื่อออกจากหน้าโดยมีข้อมูลที่ยังไม่บันทึก (ปุ่มกลับ, ปุ่ม Back เบราว์เซอร์, ปิด/รีเฟรชแท็บ)
  const { confirmLeave } = useUnsavedChangesGuard(isDirty, () =>
    navigateBackToManageProduct(navigate, location.state)
  );

  const handleBackToManageProduct = () => {
    confirmLeave(() => navigateBackToManageProduct(navigate, location.state));
  };

  // ✅ ปุ่ม "บันทึกและกลับ" — ตั้ง flag ไว้ก่อน submit แล้วให้ onFinish/mutate onSuccess เป็นคนเช็คแล้วค่อยกลับหน้า
  const saveAndBackRef = useRef(false);

  const handleSaveAndBack = () => {
    saveAndBackRef.current = true;
    form.submit();
  };

  const onFinish = (values: any) => {
    console.log("values999", values);
    // console.log("Updatevalues", values);
    // console.log("Updateattribute", attribute);
    console.log("Updatevariants", variants);
    // console.log("Updateprices", prices);

    // ✅ บังคับต้องมี SKU เฉพาะเมื่อเปิดการขาย (is_active) — บันทึกสินค้าโดยไม่มี SKU ได้
    const requireSKU = values.is_active === true;

    if (
      // _.isEmpty(attribute) ||
      (requireSKU && (_.isEmpty(variants) || _.isEmpty(prices))) ||
      _.isEmpty(values.category_id)
    ) {
      // if (_.isEmpty(attribute)) {
      //   message.error("กรุณาเพิ่มคุณลักษณะสินค้า");
      // }
      if (requireSKU && _.isEmpty(variants)) {
        message.error("กรุณาเพิ่มตัวเลือกสินค้าอย่างน้อย 1 รายการก่อนเปิดการขาย");
      }
      if (requireSKU && _.isEmpty(prices)) {
        message.error("กรุณากำหนดราคาสินค้าอย่างน้อย 1 รายการก่อนเปิดการขาย");
      }
      if (_.isEmpty(values.category_id)) {
        message.error("กรุณาเพิ่มหมวดหมู่สินค้า");
      }
      return;
    }

    let new_main_images: any = [];

    if (values.main_images) {
      new_main_images = values.main_images.map((item: any) => {
        return item.id;
      });
    }

    /**
     * ✅ แปลงข้อมูล variants จากโครงสร้างใหม่ (Single-Step SKU)
     * ให้เป็นโครงสร้างเดิมที่ backend รองรับ (เหมือน CreateProduct)
     * 
     * จาก: หลาย variants แต่ละตัวมี 1 item
     * [
     *   { id: "item1-id", name: "SKU1", items: [item1] },
     *   { id: "item2-id", name: "SKU2", items: [item2] }
     * ]
     * 
     * เป็น: 1 variant มีหลาย items (เหมือน CreateProduct)
     * [
     *   { 
     *     id: "variant-id", 
     *     name: "ตัวเลือก", 
     *     capacity: 100,
     *     items: [item1, item2] 
     *   }
     * ]
     */

    //console.log("🔍 itemToVariantMap:", itemToVariantMap);
    //console.log("🔍 variants ก่อนแปลง:", variants);

    // ✅ ดึง variant_id ตัวแรกจาก mapping (หรือใช้ variants[0].id ถ้าไม่มี)
    const firstItemId = variants[0]?.items[0]?.id;
    const firstVariantId = firstItemId ? (itemToVariantMap[firstItemId] || variants[0]?.id) : variants[0]?.id;

    //console.log("🔍 firstVariantId:", firstVariantId);

    // ✅ รวม items ทั้งหมดเป็น 1 variant (เหมือน CreateProduct)
    const convertedVariants = variants.length > 0 ? [{
      id: firstVariantId, // ใช้ variant_id จากตัวแรก
      name: "ตัวเลือก", // ชื่อกลุ่มคงที่
      capacity: 100, // ค่าคงที่
      items: variants.flatMap(v => v.items) // รวม items จากทุก variants
    }] : [];

    //console.log("🔍 convertedVariants:", convertedVariants);

    const updateProductInput: UpdateProductInput = {
      id: id,
      recomended_retail: values.recomended_retail,
      name: values.name,
      description: values.description,
      category_id: values.category_id,
      main_images: new_main_images,
      prices: prices,
      variants: convertedVariants, // ✅ ส่งข้อมูลที่แปลงแล้ว
      properties: attribute,
      is_active: values.is_active,
      is_recommend: values.is_recommend,
      is_approve: values.is_approve,
      is_show_app: values.is_show_app,
      is_dead_stock: values.is_dead_stock ?? false,
      //quickwin
      retail_type: values.retail_type,
      tag_list: values.tag_list,
      video_url: values.video_url,
      sg_important_advice: values.sg_important_advice, // Sale guide1 คำแนะนำสำคัญ
      sg_recommended_shop: values.sg_recommended_shop, // Sale guide2 แนะนำร้าน
      sg_frequently_qna: values.sg_frequently_qna, // Sale guide3 คำถามที่พบบ่อยเกี่ยวกับสินค้า
      sg_sales_income: values.sg_sales_income, // Sale guide4 ส่วนของรายได้เซ
      sg_invite_sale: values.sg_invite_sale, // Sale guide5 เชิญชวนเซลล์ชุมชนมาร่วมขายสินค้า
      sg_waiting_time: values.sg_waiting_time, // Sale guide6 ระยะเวลรอรับสินค้า
    };

    console.log("updateProductInput", updateProductInput);

    mutate(updateProductInput, {
      onSuccess: async (data) => {
        message.success("แก้ไขสินค้าสำเร็จ");
        // ✅ บันทึกแล้ว — ล้างสถานะ "ยังไม่บันทึก" เพื่อไม่ให้เตือนตอนออกจากหน้า
        setIsDirty(false);
        await queryClient.refetchQueries({
          queryKey: ["getProductList"],
          type: "active",
        });
        await queryClient.refetchQueries({
          queryKey: ["getProductListInActive"],
          type: "active",
        });
        await queryClient.refetchQueries({
          queryKey: ["getProductListActive"],
          type: "active",
        });
        await queryClient.refetchQueries({
          queryKey: ["product", id],
          type: "active",
        });
        // ✅ ถ้ากดปุ่ม "บันทึกและกลับ" ให้กลับไปหน้ารายการหลังบันทึกสำเร็จ (ไม่ผ่าน confirmLeave เพราะบันทึกแล้ว)
        if (saveAndBackRef.current) {
          saveAndBackRef.current = false;
          navigateBackToManageProduct(navigate, location.state);
        }
      },
      onError: (error: any) => {
        console.error("❌ Error:", error);
        console.error("❌ Error Response:", error?.response?.data);
        message.error("แก้ไขสินค้าไม่สำเร็จ: " + (error?.response?.data?.message || error?.message || "Unknown error"));
      },
    });
  };

  useEffect(() => {
    dispatch(setLoading(isPending));
    return () => { dispatch(setLoading(false)); };
  }, [isPending, dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/not-found");
    }
  }, [isError]);

  useEffect(() => {
    if (data) {
      /**
       * ✅ แปลงข้อมูลจาก backend ให้เข้ากับระบบ Single-Step SKU
       * 
       * โครงสร้างเดิมจาก backend: หลาย variants แต่ละตัวมี items
       * - variants = [
       *     { id: "variant1-id", name: "SKU1", items: [item1] },
       *     { id: "variant2-id", name: "SKU2", items: [item2] }
       *   ]
       * 
       * โครงสร้างใหม่ที่ต้องการ: แปลงให้ใช้ item.id เป็น key แต่เก็บ variant.id เดิมไว้
       * - variants = [
       *     { id: "item1-id", name: "SKU1", items: [item1] },
       *     { id: "item2-id", name: "SKU2", items: [item2] }
       *   ]
       * - itemToVariantMap = { "item1-id": "variant1-id", "item2-id": "variant2-id" }
       */
      const mappedVariants: VariantsInput = [];
      const tempItemToVariantMap: Record<string, string> = {}; // เก็บ mapping item.id -> variant.id

      data.product.variants.forEach((variant) => {
        // แปลงแต่ละ item ให้เป็น variant แยกกัน
        variant.items.forEach((item) => {
          // ✅ เก็บ mapping ระหว่าง item.id กับ variant.id เดิม
          tempItemToVariantMap[item.id] = variant.id;

          mappedVariants.push({
            id: variant.id, // ✅ ใช้ ID จาก item (unique สำหรับแต่ละ SKU)
            name: variant.name, // ใช้ชื่อเดิมจาก variant
            capacity: item.product_capacity, // ใช้ capacity จาก item
            items: [
              {
                id: item.id,
                name: item.name,
                image_id: item.image_id,
                image_url: item.image_url, // ✅ ส่ง image_url ให้ครบ เผื่อมุมมองคลังใช้ (fallback ของรูป)
                // ✅ ใช้ข้อมูลจริงจาก API แทน default values
                product_code: item.product_code || "",
                product_capacity: item.product_capacity,
                product_quantity: item.product_quantity,
                lead_time: item.lead_time,
                preparation_time: item.preparation_time || 1,
                width: item.width || 0,
                length: item.length || 0,
                height: item.height || 0,
                weight: item.weight || 0,
                packaging_type_id: item.packaging_type_id || null, // ✅ ส่งข้อมูล packaging_type_id ให้หน้าแก้ไข
                // ✅ สำคัญ: map shipping_method จาก API เพื่อให้ edit/copy mode ไม่ fallback เป็น "self"
                // ถ้า API ไม่ส่งมา ให้อนุมานจากมิติ/น้ำหนัก (ถ้ามีข้อมูลพัสดุ แปลว่าใช้ "ส่งกับแบ่งเบา")
                shipping_method:
                  item.shipping_method ??
                  ((item.width || 0) > 0 ||
                    (item.length || 0) > 0 ||
                    (item.height || 0) > 0 ||
                    (item.weight || 0) > 0
                    ? "bangbow"
                    : "self"),
                is_active: item.is_active !== undefined ? item.is_active : true,
                is_draft: item.is_draft || false,
                is_cod: item.is_cod ?? false,
                merchants: toMerchantIdArray(item.merchants),
                merchant_id: item.merchant_id || "",
                is_stock: item.is_stock ?? false,
                stock: item.stock ?? { stock_quantity: 0, holding_quantity: 0, stock_balance: 0 },
                partner_transport_id: item.partner_transport_id || null,
                partner_transport_brand_id: item.partner_transport_brand_id || null,
                partner_transport_brand_name: item.partner_transport_brand_name || null,
                partner_transport_brand_logo: item.partner_transport_brand_logo || null,
                include_transport_price: item.include_transport_price !== false, // default true
                self_transport_carrier_id: item.self_transport_carrier_id || null,
              }
            ],
          });
        });
      });

      // ✅ เก็บ mapping ไว้ใน state
      setItemToVariantMap(tempItemToVariantMap);
      setVariants(mappedVariants);
      // ✅ เก็บ snapshot จากฐานข้อมูล (ไม่เปลี่ยนตามการแก้ไขใน modal SKU)
      setOriginalVariants(mappedVariants);
      let apiPrices: PricesInput = [];

      data.product.prices.forEach((item: PriceProductByIdResponse) => {
        apiPrices.push({
          id: item.id,
          variant_1_item_id: item.variant_1_item_id,
          variant_2_item_id: item.variant_2_item_id,
          factory_price: Number(item.factory_price),
          retail_price: Number(item.retail_price),
          wholesale_price: Number(item.wholesale_price),
          vip_price: Number(item.vip_price),
          // ✅ ใช้ข้อมูลจริงจาก API แทน default values
          base_factory_price: item.base_factory_price || 0,
          base_wholesale_price: item.base_wholesale_price || 0,
          base_retail_price: item.base_retail_price || 0,
          base_vip_price: item.base_vip_price || 0,
          transport_price: item.transport_price || 0,
          api_transport_carrier_code: item.api_transport_carrier_code || undefined,
          api_transport_logo: item.api_transport_logo || undefined,
          // ✅ Policy A: api_transport_price มาจาก API เท่านั้น (ข้อมูลเก่า/ไม่มี field ให้เป็น 0)
          api_transport_price: Number(item.api_transport_price ?? 0),
          add_on_api_transport_price: Number(item.add_on_api_transport_price ?? 0),
          percent_payment_gateway: item.percent_payment_gateway || 3,
          // ✅ เพิ่ม: Payment Gateway และคอมมิชชั่น 3 ระดับ
          payment_getway: item.payment_getway || 0,
          // ✅ ใช้ ?? แทน || เพื่อให้ API ไม่ส่ง field / เป็น null ได้ fallback ไป editData ใน SKUModalForm (ไม่บังคับเป็น 0)
          commistion_lv1: item.commistion_lv1 ?? undefined,
          commistion_lv2: item.commistion_lv2 ?? undefined,
          commistion_lv3: item.commistion_lv3 ?? undefined,
          commistion_lv4: item.commistion_lv4 ?? undefined,
          commistion_lv5: item.commistion_lv5 ?? undefined,
          total_commission: item.total_commission ?? undefined, // ✅ เพิ่ม: ค่าคอมมิชชั่นและค่าดำเนินการ (บาท)

          // ✅ เพิ่ม: ราคาต่อหน่วย 4 ประเภท
          unit_factory_price: String(item.unit_factory_price || "0"),
          unit_wholesale_price: String(item.unit_wholesale_price || "0"),
          unit_retail_price: String(item.unit_retail_price || "0"),
          unit_vip_price: String(item.unit_vip_price || "0"),
          ...(item.quantity_per_unit != null ? { quantity_per_unit: Number(item.quantity_per_unit) } : {}),
          ...(item.product_unit != null && item.product_unit !== "" ? { product_unit: item.product_unit } : {}),
          self_transport_price: Number(item.self_transport_price ?? 0),
          include_transport_price: item.include_transport_price !== false,
          self_transport_carrier_id: item.self_transport_carrier_id ?? null,
          // ✅ preserve master_sku_tag ที่ผูกกับ SKU (เช่น sale_channel: wholesale/retail) — ใช้ pre-fill radio ใน SKUModalForm
          ...((item as any).sku_tags ? { sku_tags: (item as any).sku_tags } : {}),
        });
      });

      setPrices(apiPrices);
      // ✅ เก็บค่าจากฐานข้อมูลไว้ใน originalPrices เพื่อใช้สำหรับ restore c1-c3 เมื่อ total_commission กลับเป็นค่าเดิม
      setOriginalPrices(apiPrices);

      // ✅ ตั้งค่า field ระดับสินค้า "ครั้งเดียว" ตอนโหลดข้อมูลครั้งแรกเท่านั้น
      // ป้องกันไม่ให้การ refetch product (จากการเพิ่ม/แก้/ลบ SKU หรือปรับสต็อก) มา reset
      // ค่าที่ผู้ใช้แก้ไขไว้แต่ยังไม่กด "อัพเดตสินค้า"
      // (แต่ข้อมูล SKU/ราคาด้านบนยัง sync ทุกครั้งเพื่อสะท้อนการแก้ SKU ที่บันทึกแล้ว)
      if (initializedRef.current || tagNameLoading || categoryLoading) return;
      initializedRef.current = true;

      setAttribute(data.product.properties);

      const main_images_item: UploadFile[] = data.product.main_images.map(
        (item: string) => {
          return {
            uid: item,
            name: data.product.name,
            status: "done",
            id: item,
            url: `${backendUrl}images/${item}`,
          };
        }
      );

      setImages(main_images_item);

      setCheckIsActive(data.product.is_active);
      //รอการแก้ไขจาก backend
      setCheckIsApproved(data.product.is_approve ?? false);
      setCheckIsShowApp(data.product.is_show_app ?? false);

      // กรอง tag_list ให้เหลือเฉพาะ tag ที่ยังมีใน tagNameData (กันกรณี tag ถูกลบไปแล้วจะได้ไม่แสดงเป็น id)
      const validTagIds =
        tagNameData?.data
          ? data.product.tag_list.filter((tagId: string) =>
              tagNameData.data.some((tag: TagNameData) => tag.id === tagId)
            )
          : [];

      form.setFieldsValue({
        name: data.product.name,
        description: data.product.description,
        category_id: categoryData?.find((item: CategoryData) => item.id === data.product.category_id)?.id,
        main_images: main_images_item,
        recomended_retail: data.product.recomended_retail,
        is_active: data.product.is_active,
        is_recommend: data.product.is_recommend,
        is_approve: data.product.is_approve || false,
        is_show_app: data.product.is_show_app || false,
        is_dead_stock: data.product.is_dead_stock || false,
        //quickwin
        retail_type: data.product.retail_type.map((item: any) => {
          return item.toString();
        }),
        video_url: data.product.video_url,
        tag_list: validTagIds,
        sg_important_advice: data.product.sg_important_advice, // Sale guide1 คำแนะนำสำคัญ
        sg_recommended_shop: data.product.sg_recommended_shop, // Sale guide2 แนะนำร้านค้าเป้าหมาย
        sg_frequently_qna: data.product.sg_frequently_qna, // Sale guide3 คำถามที่พบบ่อยเกี่ยวกับสินค้า
        sg_sales_income: data.product.sg_sales_income, // Sale guide4 ส่วนของรายได้เซลล์
        sg_invite_sale: data.product.sg_invite_sale, // Sale guide5 เชิญชวนเซลล์ชุมชนมาร่วมขายสินค้า
        sg_waiting_time: data.product.sg_waiting_time, // Sale guide6 ระยะเวลารอรับสินค้า
      });
    }
  }, [data, tagNameData, tagNameLoading, categoryLoading]);

  useEffect(() => {
    if (userProfile) {
      setRoleType(userProfile.user.role.ref_type);
    }
  }, [userProfile]);

  return (
    <>
      <Form form={form} onFinish={onFinish} onValuesChange={() => setIsDirty(true)}>
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col span={24}>
            <Card bordered={false} className="criclebox h-full tabs-mobile">
              <HeaderTabs>
                {roleType !== 'admin' ? (
                  <IconWrapper
                    onClick={handleBackToManageProduct}
                  >
                    <SpanIcon>{goBack}</SpanIcon>
                  </IconWrapper>
                ) : (
                  <IconWrapper
                  >
                  </IconWrapper>
                )}
                <Typography.Title level={5}>แก้ไขสินค้า</Typography.Title>
                <RightIconWrapper></RightIconWrapper>
              </HeaderTabs>
              <WrapperAll>
                {/* <ProductAddDialogs id={id} /> */}
                <MainUpdateProduct
                  form={form}
                  onFinish={onFinish}
                  attribute={attribute}
                  setAttribute={setAttribute}
                  variants={variants}
                  setVariants={setVariants}
                  prices={prices}
                  setPrices={setPrices}
                  images={images ?? undefined}
                  checkIsActive={checkIsActive}
                  setCheckIsActive={setCheckIsActive}
                  checkIsRecommend={checkIsRecommend}
                  setCheckIsRecommend={setCheckIsRecommend}
                  checkIsApproved={checkIsApproved}
                  setCheckIsApproved={setCheckIsApproved}
                  checkIsShowApp={checkIsShowApp}
                  setCheckIsShowApp={setCheckIsShowApp}
                  setIsUpdateButtonDisabled={setIsUpdateButtonDisabled}
                  originalPrices={originalPrices}
                  originalVariants={originalVariants}
                  productId={id}
                  factoryId={data?.product?.factory?.[0]?.factory_id}
                />
              </WrapperAll>
            </Card>
          </Col>
        </Row>
        <UpdateProductProduct
          loading={mutateLoading}
          disabled={isUpdateButtonDisabled}
          onBack={handleBackToManageProduct}
          onSaveAndBack={handleSaveAndBack}
        />
      </Form>
    </>
  );
};

export default UpdateProduct;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
